<template>
  <div class="flex w-fit items-center" role="status" aria-label="Simbel AI prépare sa réponse">
    <span
      class="animate-pulse text-[20px] leading-none text-primary-blue-color motion-reduce:animate-none"
      aria-hidden="true"
    >
      ✦
    </span>
    <span class="sr-only">Réponse en cours</span>
  </div>
</template>
